<template>
  <div class="rate" :class="{'disabled':disabled}">
    <span
      v-for="i in 5"
      :key="i"
      @mouseenter="disabled?'':curScore=i"
      @mouseleave="disabled?'':curScore=''"
      @click="disabled?'':setScore(i)"
      :class="getClass(i)"
    >
      <slot></slot>
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs xmlns="http://www.w3.org/2000/svg">
            <linearGradient x1="28.8085938%" y1="27.0298549%" x2="81.5359933%" y2="88.1487165%" id="linearGradient-1">
                <stop stop-color="#7FEBF5" offset="0%"/>
                <stop stop-color="#37CAD7" offset="100%"/>
            </linearGradient>
        </defs>
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="star"  fill-rule="nonzero" :transform="getSvgAttrs(i).transform" :fill="getSvgAttrs(i).fill">
                <g transform="translate(720.000000, 93.000000)">
                    <g transform="translate(33.000000, 97.000000)">
                        <path v-if="(curScore||score) >= i" d="M62.5346589,19.7446443 L57.1522639,22.5743368 C56.6634193,22.8313376 56.0587921,22.6433911 55.8017913,22.1545465 C55.6994523,21.959886 55.6641376,21.736918 55.7013144,21.5201603 L56.7292604,15.5267754 C56.7848983,15.2023814 56.6773499,14.8713812 56.4416638,14.641644 L52.0872147,10.3971052 C51.6917312,10.011604 51.6836389,9.37849076 52.0691401,8.98300718 C52.2226487,8.82552355 52.4237911,8.72303637 52.6414281,8.69141186 L58.6591287,7.81698879 C58.9848388,7.76966033 59.2664044,7.56509095 59.4120664,7.26994748 L62.1032639,1.81698575 C62.3476862,1.32173209 62.9473121,1.11839309 63.4425657,1.36281539 C63.6397783,1.46014562 63.7994058,1.61977315 63.8967361,1.81698575 L66.5879336,7.26994748 C66.7335956,7.56509095 67.0151612,7.76966033 67.3408713,7.81698879 L73.3585719,8.69141186 C73.9051167,8.77082948 74.2837982,9.27827233 74.2043806,9.82481719 C74.1727561,10.0424542 74.0702689,10.2435966 73.9127853,10.3971052 L69.5583362,14.641644 C69.3226501,14.8713812 69.2151017,15.2023814 69.2707396,15.5267754 L70.2986856,21.5201603 C70.3920466,22.0644968 70.0264588,22.5814527 69.4821223,22.6748137 C69.2653647,22.7119906 69.0423966,22.6766759 68.8477361,22.5743368 L63.4653411,19.7446443 C63.1740171,19.5914862 62.8259829,19.5914862 62.5346589,19.7446443 Z" id="star-fill"/>
                        <path v-else d="M11.5346589,19.7446443 L6.15226387,22.5743368 C5.66341929,22.8313376 5.05879213,22.6433911 4.80179132,22.1545465 C4.69945225,21.959886 4.66413758,21.736918 4.70131442,21.5201603 L5.7292604,15.5267754 C5.78489833,15.2023814 5.67734985,14.8713812 5.44166376,14.641644 L1.08721474,10.3971052 C0.691731161,10.011604 0.683638855,9.37849076 1.06914007,8.98300718 C1.22264867,8.82552355 1.42379108,8.72303637 1.64142811,8.69141186 L7.65912866,7.81698879 C7.98483882,7.76966033 8.26640441,7.56509095 8.41206642,7.26994748 L11.1032639,1.81698575 C11.3476862,1.32173209 11.9473121,1.11839309 12.4425657,1.36281539 C12.6397783,1.46014562 12.7994058,1.61977315 12.8967361,1.81698575 L15.5879336,7.26994748 C15.7335956,7.56509095 16.0151612,7.76966033 16.3408713,7.81698879 L22.3585719,8.69141186 C22.9051167,8.77082948 23.2837982,9.27827233 23.2043806,9.82481719 C23.1727561,10.0424542 23.0702689,10.2435966 22.9127853,10.3971052 L18.5583362,14.641644 C18.3226501,14.8713812 18.2151017,15.2023814 18.2707396,15.5267754 L19.2986856,21.5201603 C19.3920466,22.0644968 19.0264588,22.5814527 18.4821223,22.6748137 C18.2653647,22.7119906 18.0423966,22.6766759 17.8477361,22.5743368 L12.4653411,19.7446443 C12.1740171,19.5914862 11.8259829,19.5914862 11.5346589,19.7446443 Z M10.9762495,18.6824866 C11.6171624,18.3455388 12.3828376,18.3455388 13.0237505,18.6824866 L18.047451,21.3236023 L17.0880096,15.7296295 C16.9656062,15.0159625 17.2022128,14.2877621 17.7207222,13.7823404 L21.7849813,9.82066683 L16.1683134,9.0045172 C15.451751,8.9003946 14.8323067,8.45034198 14.5118503,7.80102634 L12,2.71146175 L9.48814972,7.80102634 C9.16769329,8.45034198 8.548249,8.9003946 7.83168664,9.0045172 L2.21501866,9.82066683 L6.27927779,13.7823404 C6.79778718,14.2877621 7.03439385,15.0159625 6.91199039,15.7296295 L5.95254895,21.3236023 L10.9762495,18.6824866 Z" id="star-stroke"></path>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    </span>
    <span v-if="showText" class="text" :class="{active: (curScore || score)>0}">{{curScore||score}}</span>
  </div>
</template>

<script>
const starFill = {
  transform: 'translate(-803.000000, -191.000000)',
  fill: 'url(#linearGradient-1)'
}
const starO = {
  transform: 'translate(-753.000000, -191.000000)',
  fill: '#DAE0E5'
}
export default {
  name: 'StarRating',
  props: {
    score: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      curScore: ''
    }
  },
  methods: {
    getSvgAttrs (i) {
      if (this.curScore === '') {
        return i <= this.score ? starFill : starO
      } else {
        return i <= this.curScore ? starFill : starO
      }
    },
    getClass (i) {
      if (this.curScore === '') {
        return i <= this.score ? 'icon-star' : 'icon-star-o'
      } else {
        return i <= this.curScore ? 'icon-star' : 'icon-star-o'
      }
    },
    setScore (i) {
      const score = this.score === this.curScore ? 0 : i
      this.$emit('update:score', score) // 使用`.sync`修饰符，对score 进行“双向绑定
    }
  }
}
</script>
<style lang="scss" scoped>
[class^="icon-star"]{
  display: inline-block;
  width:26px;
  height:26px;
  margin-right: 24px;
  vertical-align: middle;
  &:hover{
    cursor: pointer;
  }
  path{
    display: none;
  }
  .disabled {
    cursor:not-allowed;
  }
}
.icon-star {
 #star-fill{
   display: block;
 }

}
.icon-star-o {
  display: inline-block;
  #star-stroke{
   display: block;
 }
}
.text{
  font-size:28px;
  font-family:SFProDisplay-Medium,SFProDisplay;
  font-weight:500;
  line-height:24px;
  color: #DAE0E5;
  padding-left: 5px;
  vertical-align: middle;
  display: inline-block;
  &.active{
    color:rgba(55,202,215,1);
  }
}
</style>
